export default __webpack_public_path__ + "static/media/gta@2x.d15b6442.webp";